/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import difference from 'lodash/difference';
import type { JiraConfigurableNavigationItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { defaultProps } from '@jira/platform__default-props/src/defaultProps.tsx';

import { expVal } from '@atlassian/jira-feature-experiments';

import {
	USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS,
	USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS_GOALS_TEAMS_SWITCHED,
} from '../../common/constants/index.tsx';

// Add back any menu ids missing from the nav items.
// Add them to the end with a default visibility of true.
export const useRefreshL1MenuItems = (
	navItems: readonly JiraConfigurableNavigationItem[] = defaultProps.emptyArray,
): JiraConfigurableNavigationItem[] =>
	useMemo(() => {
		const missingMenuIds = difference(
			expVal('navx-1982-change-order-of-teams-and-goals', 'isEnabled', false)
				? USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS_GOALS_TEAMS_SWITCHED
				: USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS,
			navItems.map(({ menuId }) => menuId),
		);

		return [...navItems, ...missingMenuIds.map((menuId) => ({ menuId, isVisible: true }))];
	}, [navItems]);
